import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  electedSeats: number;
  totalSeats: number;
  isProportional: boolean;
}
const ElectionTeaserResult = ({ electedSeats, totalSeats, isProportional }: Props) => {
  const { t } = useTranslation('wap');

  return (
    <div className="electionteaser__result">
      {isProportional ? (
        t('election_teaser_proportional_result')
      ) : (
        <Trans
          t={t}
          i18nKey="election_result"
          values={{ electedSeats }}
          count={totalSeats}
        >
          <div className="electionteaser__result-label">electedSeats</div>
          <div className="electionteaser__result-details">von</div>
          <div className="electionteaser__result-label">totalSeats</div>
          <div className="electionteaser__result-details">Sitzen vergeben</div>
        </Trans>
      )}
    </div>
  );
};

export default ElectionTeaserResult;
